import React, {useEffect, useState} from 'react';
import {Stack, Typography} from "@mui/material";
import {LocalDocumentOcrVersionResponse} from "../../../../../models/local-documents.models";
import {useTranslation} from "react-i18next";
import PageNavigation from "../../../../../components/ocr-batch/PageNavigation";
import {ResultText} from "../../../../ocr-batch/components/ResultPanel/ResultPanel.styled";
import {FilePreviewResultWrapper} from "./FilePreviewResult.styled";

interface FilePreviewResultProps {
    result: LocalDocumentOcrVersionResponse;
}

const FilePreviewResult = ({result}: FilePreviewResultProps) => {
    const {t} = useTranslation();
    const {pages} = result;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [pages]);

    return (
        <FilePreviewResultWrapper>
            {pages.length === 0 ? (
                    <ResultText aria-live="polite" aria-label={t('digitizationDetails.filePreview.ocrResultNotFound')}>
                        {t('digitizationDetails.filePreview.ocrResultNotFound')}
                    </ResultText>
                )
                : (
                    <Stack direction="column" spacing={2} sx={{width: '100%', height: '100%'}}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{borderBottom: 'solid 0.8px #E2E8F0'}}>
                            <Typography variant="body2" color="text.secondary" fontWeight={500}>
                                {t('digitizationDetails.filePreview.confidencePercentage', {percentage: pages[currentPage - 1].confidencePercent})}
                            </Typography>

                            <PageNavigation
                                currentPage={currentPage}
                                totalPages={pages.length}
                                setCurrentPage={setCurrentPage}
                            />
                        </Stack>

                        <ResultText role="region" aria-label={t('digitizationDetails.filePreview.pageInfo', {current: currentPage, total: pages.length})}>
                            {pages[currentPage - 1].text}
                        </ResultText>

                    </Stack>
                )}
        </FilePreviewResultWrapper>
    );
};

export default FilePreviewResult;